import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/material';
import { InboxOutlined as InboxOutlinedIcon } from '@mui/icons-material';
import { alpha, useTheme } from '@mui/material/styles';

const EmptyState = ({
  title = 'No results found',
  description = 'Try changing your filters or search text.',
  icon = null,
  action = null,
  sx = {},
}) => {
  const theme = useTheme();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={0.9}
      sx={{
        py: { xs: 2.8, md: 3.6 },
        px: { xs: 1.4, md: 2.2 },
        textAlign: 'center',
        color: 'text.secondary',
        ...sx,
      }}
    >
      <Box
        sx={{
          color: alpha(theme.palette.primary.main, 0.7),
          display: 'grid',
          placeItems: 'center',
          lineHeight: 1,
        }}
      >
        {icon || <InboxOutlinedIcon sx={{ fontSize: 28 }} />}
      </Box>
      <Typography variant="subtitle2" sx={{ color: 'text.primary', fontWeight: 700 }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ maxWidth: 420, color: 'text.secondary' }}>
        {description}
      </Typography>
      {action ? <Box sx={{ pt: 0.45 }}>{action}</Box> : null}
    </Stack>
  );
};

EmptyState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.node,
  action: PropTypes.node,
  sx: PropTypes.object,
};

export default EmptyState;
